export const COIN = 'coin';
export const MONEY = 'money';
export const ENERGY = 'energy';
export const CHARM = 'charm';
export const PROMO = 'promo';
export const XP = 'xp';
export const SCORE = 'score';
export const TICKET = 'ticket';
export const PRIZE = 'prize';
export const GACHA_ITEM = 'gachaItem';
export const RARE_BOX = 'rareBox';
export const BOX = 'box';
export const BONUSES = 'bonuses';
export const BONUSES_FIRE = 'bonusesFire';
export const BEAUTIES = 'beauties';

export const icons = {
  [COIN]: 'reward/coin-blue.png',
  [MONEY]: 'reward/coin.png',
  [ENERGY]: 'reward/energy.png',
  [CHARM]: 'reward/charm.png',
  [PROMO]: 'reward/promo.png',
  [XP]: 'reward/xpb.png',
  [SCORE]: 'reward/xp.png',
  [TICKET]: 'reward/ticket-raffle.png',
  [PRIZE]: 'games/prize.png',
  [GACHA_ITEM]: 'main/box.png',
  [RARE_BOX]: 'lootboxes/rare.png',
  [BOX]: 'lootboxes/standard.png',
  [BONUSES]: 'reward/bonuses.png',
  [BONUSES_FIRE]: 'reward/bonusesFire.png',
  [BEAUTIES]: 'reward/beauties.png',
};
